import React, {useEffect, useState} from 'react';
import {Box, Grid, Input, Typography, FormControl} from '@deere/fuel-react';
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {ChartsGraphs} from "@deere/ux.uxframe-react";
import {useStyles} from "../shared/styles/Ratings";
import {RatingsActions} from "./RatingsActions";
import {Controller, useForm} from "react-hook-form";
import {toRound, shouldDefaultToNA} from "../shared/utils";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import {withStyles} from "@material-ui/core/styles";
import Rating from "@material-ui/lab/Rating";

const StyledRating = withStyles({
    iconFilled: {
        color: '#F2A900',
    }
})(Rating);

export const RatingCriteriaSummary = ({
                                        criteria,
                                        isActionsAllowed,
                                        onCommentClick,
                                        criteriaComments,
                                        userInfo,
                                        isSupplierMimic,
                                        isSupplierAdmin,
                                        onOverrideScoreClick,
                                        onOverrideScoreSave,
                                        isOverrideEdit,
                                        isOverrideScoreOpen,
                                        overrideValueInitial,
                                        isEditOverrideScoreOpen,
                                        onNotApplicableClick,
                                        isNotApplicableEdit
                                    }) => {
    const classes = useStyles();
    const {control} = useForm();
    const [commentsCount, setCommentsCount] = useState(0)
    const [responses, setResponses] = useState([])
    const [recordedResponses, setRecordedResponses] = useState([])
    const [isEdit, setIsEdit] = useState(false)
    const [noOfYes, setNoOfYes] = useState([])
    const [totalYesOrNo, setTotalYesOrNo] = useState([])
    const [chartData, setChartData] = useState({})
    const [anchorEl, setAnchorEl] = useState(null);
    const [overrideValue, setOverrideValue] = useState("");
    const loggedInUser = userInfo && userInfo.userId
    const isSupplier = userInfo && userInfo.isSupplier

    const likertScaleResponses = criteria.responseType.id === 2 && criteria.feedbacks.filter(item => item.feedback.notApplicable === false && item.feedback.rating !== "");
    const averageStarRating = likertScaleResponses.length > 0 ? likertScaleResponses.reduce((total, next) => total + parseInt(next.feedback.rating), 0) / likertScaleResponses.length : 0;
    const averageStarRatingDefaultValue = toRound(averageStarRating)

    const custLikertScaleResponses = criteria.responseType.id === 4 && criteria.feedbacks.filter(item => item.feedback.notApplicable === false && item.feedback.rating !== "");
    const custLikertAveragePointRange = custLikertScaleResponses.length > 0 ? (custLikertScaleResponses.reduce((total, next) => total + parseInt(next.feedback.custLikertPointRange), 0) / (custLikertScaleResponses.length * 100)) * 100 : 0;
    const minLikertRangeList = custLikertAveragePointRange > 0 ? criteria.custLikertRanges.filter(custLikertRange => custLikertRange.pointsRange < custLikertAveragePointRange) : [];
    // const minLikertRange = custLikertAveragePointRange > 0 ? minLikertRangeList.at(minLikertRangeList.length - 1) : [];
    const minLikertRange = custLikertAveragePointRange > 0 ? minLikertRangeList.sort((a, b) => a.order > b.order ? 1 : -1).at(minLikertRangeList.length - 1) : [];
    // const maxLikertRange = custLikertAveragePointRange > 0 ? criteria.custLikertRanges.filter(custLikertRange => custLikertRange.pointsRange >= custLikertAveragePointRange).at(0) : [];
    const maxLikertRange = custLikertAveragePointRange > 0 ? criteria.custLikertRanges.filter(custLikertRange => custLikertRange.pointsRange >= custLikertAveragePointRange).sort((a, b) => a.order > b.order ? 1 : -1).at(0) : [];
    const custLikertAverageStarRating = custLikertScaleResponses.length > 0 ? minLikertRange.pointsRange === maxLikertRange.pointsRange ? 1 : minLikertRange.order + (custLikertAveragePointRange - minLikertRange.pointsRange)/(maxLikertRange.pointsRange - minLikertRange.pointsRange) : 0;
    const custLikertAverageStarRatingDefaultValue = toRound(custLikertAverageStarRating)

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleAddEditComment = (type) => {
        onCommentClick(criteria.id, type);
        setAnchorEl(null);
    };

    const handleOverrideScore = (type) => {
        onOverrideScoreClick(criteria.id, type);
        setAnchorEl(null);
    }

    const handleNotApplicable = (type) => {
        onNotApplicableClick(criteria.id, type);
        setAnchorEl(null);
    }

    useEffect(() => {
            if (criteria.responseType.id === 1) {
                const noOfYesResponses = criteria.feedbacks.filter(item => item.feedback.notApplicable === false && item.feedback.yesNoChoice === "Y").length
                const noOfNoResponses = criteria.feedbacks.filter(item => item.feedback.notApplicable === false && item.feedback.yesNoChoice === "N").length
                const yesOrNoResp = criteria.feedbacks.filter(item => item.feedback.notApplicable === false && (item.feedback.yesNoChoice === "N" || item.feedback.yesNoChoice === "Y")).length
                setResponses(criteria.feedbacks.filter(item => item.feedback.notApplicable === true || item.feedback.declined === true || item.feedback.yesNoChoice !== ""))
                setNoOfYes(noOfYesResponses)
                setTotalYesOrNo(yesOrNoResp)
                setChartData({
                    labels: ["Yes", "No"],
                    datasets: [{
                        data: [noOfYesResponses, noOfNoResponses],
                        backgroundColor: ["#006400", "#FFDE00"],
                        borderWidth: [0, 0]
                    }]
                })
            } else if (criteria.responseType.id === 2) {
                setResponses(criteria.feedbacks.filter(item => item.feedback.notApplicable === false && item.feedback.rating !== ""));
                setRecordedResponses(criteria.feedbacks.filter(item => item.feedback.notApplicable === true || item.feedback.declined === true || item.feedback.rating !== ""));
            } else if (criteria.responseType.id === 4) {
                setResponses(criteria.feedbacks.filter(item => item.feedback.notApplicable === false && item.feedback.rating !== ""));
                setRecordedResponses(criteria.feedbacks.filter(item => item.feedback.notApplicable === true || item.feedback.declined === true || item.feedback.rating !== ""));
            }

        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [criteria]);

    useEffect(() => {
            if (criteria.overridePoints !== null || criteria.overrideReason) {
                setOverrideValue(criteria.overridePoints)
            } else
                setOverrideValue(overrideValueInitial)
            return () => {
                setOverrideValue("");
            } // eslint-disable-next-line react-hooks/exhaustive-deps
        },
        [criteria.overridePoints, criteria.overrideReason, overrideValueInitial]);

    useEffect(() => {
            const allComments = criteria.feedbacks.filter(item => item.feedback.comment !== "")
            const visibleComments = criteria.feedbacks.filter(item => item.feedback.isCommentVisible)
            const visibleCriteriaComments = criteriaComments.filter(item => item.isCommentVisible)
            setCommentsCount(isSupplierAdmin ? (allComments.length + criteriaComments.length) : (visibleComments.length + visibleCriteriaComments.length))

        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [criteria, criteriaComments]);

    useEffect(() => {
            const allCommentsUserId = criteriaComments && criteriaComments.map(item => Object.keys(item.user).length !== 0 && item.user.racfID.toUpperCase())
            if (loggedInUser && allCommentsUserId.includes(loggedInUser.toUpperCase()))
                setIsEdit(true)
            else
                setIsEdit(false)
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [loggedInUser, criteriaComments]);

    return (
        <Grid container alignItems="center">
            <Grid item xs={12} md={7}>
                <AccordionSummary
                    className={classes.accordionSummary}
                    classes={{
                        expandIcon: classes.expandIcon,
                        content: classes.content,
                        expanded: classes.expanded
                    }}
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <Box display="flex"
                         justifyContent="flex-start"
                         alignItems="center"
                         alignContent="center">
                        <Typography
                            style={{wordBreak: "break-word"}}
                            color="primary" size="md">
                            {criteria.criteria}
                            {criteria.isRequired ? (
                                <span style={{
                                    marginLeft: ".25rem",
                                    display: "inline"
                                }}
                                      aria-label="required field"
                                      className="uxf-is-required"
                                > * </span>
                            ) : ""}
                        </Typography>
                    </Box>
                </AccordionSummary>
            </Grid>
            <Grid item xs={12} md={5}>
                <Box m={2} display="flex" alignItems="center" justifyContent="flex-end">
                    <Grid container justifyContent="flex-end">
                        <Grid item xs={12}>
                            <Box display="flex" justifyContent="flex-end">
                                <Box display="inline-flex" flexDirection={isSupplier ? "rows": "column"} alignItems={isSupplier ? "center": "flex-end"} justifyContent="flex-end">
                                    <Grid item xs={12}>
                                        <Box display="flex"
                                             justifyContent="flex-end" alignContent="center">
                                            {criteria.responseType.id === 1 &&
                                            <>
                                                <ChartsGraphs
                                                    type="pie"
                                                    data={chartData}
                                                    height={25} width={25}
                                                    id={criteria.id}
                                                    options={{
                                                        legend: {
                                                            display: false
                                                        }
                                                    }}
                                                />
                                                <Typography
                                                    display="inline"
                                                    style={{marginLeft: ".25rem", marginRight: ".25rem"}}>
                                                    {noOfYes}/{totalYesOrNo}
                                                </Typography>
                                                <Typography
                                                    display="inline"
                                                    style={{paddingRight: ".5rem", paddingLeft: ".25rem"}}>
                                                    Yes
                                                </Typography>
                                            </>
                                            }
                                            {criteria.responseType.id === 2 &&
                                            <>
                                                <StyledRating
                                                    value={averageStarRatingDefaultValue}
                                                    emptyIcon={<StarBorderIcon
                                                        fontSize="inherit"/>}
                                                    readOnly={true}
                                                    size="large"
                                                    precision={0.5}
                                                    max={5}
                                                />
                                                <Typography size="lg"
                                                            display="inline"
                                                            style={{paddingRight: ".5rem", paddingLeft: ".25rem"}}>
                                                    {toRound(averageStarRating)}
                                                </Typography>
                                            </>
                                            }
                                            {criteria.responseType.id === 4 &&
                                            <>
                                                <StyledRating
                                                    value={custLikertAverageStarRatingDefaultValue}
                                                    emptyIcon={<StarBorderIcon
                                                        fontSize="inherit"/>}
                                                    readOnly={true}
                                                    size="large"
                                                    precision={0.5}
                                                    max={criteria.custLikertRanges.length}
                                                />
                                                <Typography size="lg"
                                                            display="inline"
                                                            style={{paddingRight: ".5rem", paddingLeft: ".25rem"}}>
                                                    {toRound(custLikertAverageStarRating)}
                                                </Typography>
                                            </>
                                            }
                                        </Box>
                                    </Grid>
                                    {!isSupplier && !isSupplierMimic &&
                                    <Grid item xs={12}>
                                        {criteria.feedbacks.length === 0 ?
                                            <Box display="flex"
                                                 justifyContent="flex-end" pl={1} pr={1} pt={2} pb={2}>
                                                <Typography color="tertiary" size="sm">
                                                    {0}/{criteria.feedbacks.length} Responses, {0} Comments
                                                </Typography>
                                            </Box>
                                            :
                                            <Box display="flex"
                                                 justifyContent="flex-end" pl={1} pr={1} pt={2} pb={2}>
                                                {criteria.responseType.id === 1 &&
                                                <Typography color="tertiary" size="sm">
                                                    {responses.length}/{criteria.feedbacks.length} Responses, {commentsCount} {commentsCount === 1 ? 'Comment' : 'Comments'}
                                                </Typography>
                                                }
                                                {criteria.responseType.id === 2 &&
                                                <Typography color="tertiary" size="sm">
                                                    {recordedResponses.length}/{criteria.feedbacks.length} Responses, {commentsCount} {commentsCount === 1 ? 'Comment' : 'Comments'}
                                                </Typography>
                                                }
                                                {criteria.responseType.id === 4 &&
                                                    <Typography color="tertiary" size="sm">
                                                        {recordedResponses.length}/{criteria.feedbacks.length} Responses, {commentsCount} {commentsCount === 1 ? 'Comment' : 'Comments'}
                                                    </Typography>
                                                }
                                            </Box>
                                        }
                                    </Grid>
                                    }
                                </Box>
                                <Typography size="md" style={{paddingTop: ".75rem"}}
                                            display="inline">|</Typography>
                                {criteria.overridePoints !== null && isOverrideEdit && !isOverrideScoreOpen && !isEditOverrideScoreOpen && criteria.notApplicableReason === null ?
                                    <>
                                        <Box display="inline-flex" flexDirection="column" justifyContent="flex-end">
                                            <Grid item xs={12}>
                                                <Box display="flex"
                                                     justifyContent="center" pl={1} pr={1}>
                                                    <Typography size="xl" fontWeight={"semibold"}
                                                                display="inline">
                                                        {criteria.points}/{criteria.weightage}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Box display="flex" justifyContent="center" pl={1} pr={1} pt={2} pb={2}>
                                                    <Typography color="tertiary" size="sm">
                                                        Original
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Box>
                                        <Typography size="md" style={{paddingTop: ".75rem"}}
                                                    display="inline">|</Typography>
                                        <Box display="inline-flex" flexDirection="column">
                                            <Grid item xs={12}>
                                                <Box display="flex"
                                                     justifyContent="center" pl={2} pr={1}>
                                                    <Typography size="xl" fontWeight={"semibold"}
                                                                display="inline">
                                                        {criteria.overridePoints}/{criteria.weightage}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Box display="flex" justifyContent="center" pl={1} pr={1} pt={2} pb={2}>
                                                    <Typography color="tertiary" size="sm">
                                                        Override
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Box>
                                    </>
                                    :
                                    <>
                                        {criteria.notApplicableReason || shouldDefaultToNA(criteria) ?
                                            <Box display="inline-flex" flexDirection="column" pt={3}
                                                 justifyContent="flex-end">
                                                <Grid item xs={12}>
                                                    <Box display="flex"
                                                         justifyContent="center" pl={1} pr={1}>
                                                        <Typography size="xl" fontWeight={"semibold"}
                                                                    display="inline">
                                                            N/A
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            </Box>
                                            :
                                            <Box display="inline-flex" flexDirection="column" justifyContent="flex-end">
                                                <Grid item xs={12}>
                                                    {(criteria?.points === null) ?
                                                        <Box display="flex"
                                                             justifyContent="center" pl={1} pr={1}>
                                                            <Typography size="xl" fontWeight={"semibold"}
                                                                        display="inline">
                                                                -/{criteria.weightage}
                                                            </Typography>
                                                        </Box>
                                                        :
                                                        <Box display="flex"
                                                             justifyContent="center" pl={1} pr={1}>
                                                            <Typography size="xl" fontWeight={"semibold"}
                                                                        display="inline">
                                                                {criteria.points}/{criteria.weightage}
                                                            </Typography>
                                                        </Box>
                                                    }
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Box display="flex" justifyContent="center" pl={1} pr={1} pt={2}
                                                         pb={2}>
                                                        <Typography color="tertiary" size="sm">
                                                            Points
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            </Box>
                                        }
                                    </>
                                }
                                {(isOverrideScoreOpen || isEditOverrideScoreOpen) &&
                                <Box display="inline-flex" flexDirection="column">
                                    <Grid item xs={12}>
                                        <Box display="flex"
                                             justifyContent="center" pl={1} pr={1} alignContent="center"
                                             alignItems="center">
                                            <FormControl style={{width: "50px"}}>
                                                <Controller
                                                    control={control}
                                                    defaultValue={overrideValue}
                                                    value={overrideValue}
                                                    name={"overrideValue"}
                                                    render={({onChange, value}) => (
                                                        <Input
                                                            id="overrideValue"
                                                            value={value}
                                                            placeholder="-"
                                                            onChange={(e) => {
                                                                onChange(e.target.value)
                                                                setOverrideValue(e.target.value)
                                                                onOverrideScoreSave(criteria.weightage, e.target.value);
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                            <Typography size="xl" fontWeight={"semibold"}
                                                        display="inline" style={{paddingTop: ".5rem"}}>
                                                /{criteria.weightage}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Box>
                                }
                                {(isActionsAllowed && !isSupplierMimic) &&
                                <RatingsActions
                                    onClose={handleClose}
                                    onActionsClick={handleClick}
                                    anchorEl={anchorEl}
                                    isRequired={criteria.isRequired}
                                    onCommentsClick={handleAddEditComment}
                                    isEdit={isEdit}
                                    onOverrideScoreClick={handleOverrideScore}
                                    overrideEdit={isOverrideEdit}
                                    onNotApplicableClick={handleNotApplicable}
                                    notApplicableEdit={isNotApplicableEdit}
                                />
                                }
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
        </Grid>
    )
}
